import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "2e480eb8-c273-468a-8649-1876bb99b7e1",
    label: "DG(BLDG)'s Circular No. 10 of 2017-18",
    date: "15/03/2018",
    subject:
      "Workshop on Energy Conservation Building Code-ECBC Circular No. 10 of 2017-18",
  },
  {
    fileStoreId: "83ad4959-5d31-41d8-ba47-6a6d3bda256d",
    label: "DG(BLDG)'s Circular No. 09 of 2017-18",
    date: "28/02/2018",
    subject:
      "Verification of permissible height as required by the AAI from latest version of CCZM Circular No. 09 of 2017-18",
  },
  {
    fileStoreId: "3b7af117-fc5f-40c1-a3dc-1d64540b51fa",
    label: "DG(BLDG)'s Circular No. 08 of 2017-18",
    date: "26/12/2017",
    subject:
      "Online Notice of Commencement and CC for Br VI and VII from 02012018 Circular No. 08 of 2017-18",
  },
  {
    fileStoreId: "1b9d2ff5-5094-472c-ae92-5c14466c1f2f",
    label: "DG(BLDG)'s Circular No. 07 of 2017-18",
    date: "13/12/2017",
    subject:
      "Original green certificate has to be submitted Circular No. 07 of 2017-18",
  },
  {
    fileStoreId: "3c1f7007-86bb-4493-bdb3-726cdc9c0f67",
    label: "DG(BLDG)'s Circular No. 06 of 2017-18",
    date: "13/10/2017",
    subject:
      "Completion plan for partial & Block building Circular No. 06 of 2017-18",
  },
  {
    fileStoreId: "945d4a16-bc79-4af5-a750-2a46f4ca8b26",
    label: "DG(BLDG)'s Circular No. 04 of 2017-18",
    date: "01/08/2017",
    subject:
      "Building Plan in Small Plot and Small Scale Industrial Building with less open space Circular No. 4 of 2017-18",
  },
  {
    fileStoreId: "2c1eb14b-c59e-433b-9a3f-f414044e7734",
    label: "DG(BLDG)'s Circular No. 02 of 2017-18",
    date: "01/07/2017",
    subject: "Section 412A Circular No. 02",
  },
];

const Building_Sanction_Circular_2017_18 = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2017-18"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2017_18;
